import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addFriendAnimationToSprite, getFriendFrameName } from '../AnimationManager';

export default class AnimatedFriend extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,creaturetype, typeid, offsets) {
    super(scene);

    this.typeID = null;
    this.offsets = null;

    this.isSwimming = false;
    this.tailDirection = null;
    this.tailAnimationListener = null;

    this.blinkWaiter = null;
    this.tailWaiter = null;

    this.stopOutline = null;

    // eslint-disable-next-line no-param-reassign
    if (!creaturetype) creaturetype = 'Fish';
    this.creatureType = creaturetype;
    this.typeID = typeid;
    this.offsets = offsets;
    this.blinkWaiter = Phaser.Math.Between(2,4);

    this.bodyAnimation = `${this.creatureType}_${this.typeID}_Body_Idle`;
    this.swimAnimation = `${this.creatureType}_${this.typeID}_Body_Swim`;
    this.eyesAnimation = `${this.creatureType}_${this.typeID}_Eyes_Idle`;
    this.blinkAnimation = `${this.creatureType}_${this.typeID}_Eyes_Blink`;

    const bodyName = getFriendFrameName(this.bodyAnimation);
    this.bodySprite = this.scene.add.sprite(this.offsets.body.x, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, bodyName);

    const eyesName = getFriendFrameName(this.eyesAnimation);
    this.eyes = this.scene.add.sprite(this.offsets.eyes.x, this.offsets.eyes.y, ABCyaPhaser.Images.DEFAULT_ATLAS, eyesName);

    this.setupAnimations();
    addFriendAnimationToSprite(this.eyes, this.blinkAnimation, false);

    this.add([this.bodySprite, this.eyes]);
  }

  setupAnimations() {
    addFriendAnimationToSprite(this.bodySprite, this.bodyAnimation);
    addFriendAnimationToSprite(this.bodySprite, this.swimAnimation, false);
    addFriendAnimationToSprite(this.eyes, this.eyesAnimation);
  }

  startSwimming () {
    this.isSwimming = true;
    if (this.bodySprite.anims.exists(this.swimAnimation)) {
      this.bodySprite.play(this.swimAnimation);
    }
    else {
      this.bodySprite.setFrame(getFriendFrameName(this.swimAnimation));
    }
  }

  tick (delta) {
    if (this.blinkWaiter < 0) {
      this.eyes.play(this.blinkAnimation);
      this.blinkWaiter = Phaser.Math.Between(2, 30);
    }
    else {
      this.blinkWaiter -= 1 * delta;
    }
  }
}